import { template } from "@ember/template-compiler";
import styles from '@hokulea/core/actions.module.css';
import disabled from '../../modifiers/disabled';
import type { TOC } from '@ember/component/template-only';
import type { Importance, Importances, Intent, Intents, Spacing, Spacings } from '@hokulea/tokens';
export interface ResetSignature {
    Element: HTMLButtonElement;
    Args: {
        intent?: Intent | Intents;
        importance?: Importance | Importances;
        spacing?: Spacing | Spacings;
        disabled?: boolean;
    };
    Blocks: {
        /** The label for the button */ default: [];
        /** The label for the button */ label: [];
        /** A slot in front of the label */ before: [];
        /** A slot after the label */ after: [];
    };
}
const Reset: TOC<ResetSignature> = template(`
  <button
    type="reset"
    class={{styles.button}}
    data-intent={{if @intent @intent "action"}}
    data-importance={{if @importance @importance "supreme"}}
    data-spacing={{@spacing}}
    {{disabled when=(if @disabled @disabled false)}}
    data-test-button
    ...attributes
  >
    {{#if (has-block "before")}}
      <span data-test-button="before">
        {{yield to="before"}}
      </span>
    {{/if}}

    <span data-test-button="label">
      {{#if (has-block "label")}}
        {{yield to="label"}}
      {{/if}}

      {{#if (has-block)}}
        {{yield}}
      {{/if}}
    </span>

    {{#if (has-block "after")}}
      <span data-test-button="after">
        {{yield to="after"}}
      </span>
    {{/if}}
  </button>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default Reset;
//# sourceMappingURL=data:application/json;base64,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-XG5cbiAgICB7eyNpZiAoaGFzLWJsb2NrIFwiYWZ0ZXJcIil9fVxuICAgICAgPHNwYW4gZGF0YS10ZXN0LWJ1dHRvbj1cImFmdGVyXCI-XG4gICAgICAgIHt7eWllbGQgdG89XCJhZnRlclwifX1cbiAgICAgIDwvc3Bhbj5cbiAgICB7ey9pZn19XG4gIDwvYnV0dG9uPlxuPC90ZW1wbGF0ZT47XG5cbmV4cG9ydCBkZWZhdWx0IFJlc2V0O1xuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxPQUFPLFlBQVksbUNBQW1DO0FBRXRELE9BQU8sY0FBYywyQkFBMkI7QUFFaEQsY0FBYyxHQUFHLFFBQVEsaUNBQWlDO0FBQzFELGNBQWMsVUFBVSxFQUFFLFdBQVcsRUFBRSxNQUFNLEVBQUUsT0FBTyxFQUFFLE9BQU8sRUFBRSxRQUFRLFFBQVEsa0JBQWtCO0FBRW5HLGlCQUFpQjtJQUNmLFNBQVM7SUFDVDtRQUNFLFNBQVMsU0FBUztRQUNsQixhQUFhLGFBQWE7UUFDMUIsVUFBVSxVQUFVO1FBQ3BCLFdBQVcsT0FBTzs7SUFFcEI7UUFDRSw2QkFBNkIsR0FDN0I7UUFFQSw2QkFBNkIsR0FDN0I7UUFFQSxpQ0FBaUMsR0FDakM7UUFFQSwyQkFBMkIsR0FDM0I7OztBQUlKLE1BQU0sT0FBTyxJQUFJLGtCQUFrQixTQUFVLENBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQWlDN0MsQ0FBQSxFQUFBO0lBQUE7UUFBQSxPQUFBLEtBQUEsU0FBQSxDQUFBLEVBQVc7SUFBRDtBQUFBO0FBRVYsZUFBZSxNQUFNIn0